import { render, staticRenderFns } from "./DiscussionBoard.vue?vue&type=template&id=73eeb58e&scoped=true&"
import script from "./DiscussionBoard.vue?vue&type=script&lang=js&"
export * from "./DiscussionBoard.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionBoard.vue?vue&type=style&index=0&id=73eeb58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eeb58e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VCol,VContainer,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VRow,VSheet,VSkeletonLoader,VTextField})
